import s from "./home.module.css";

/** Platzhalter-Bild: Silhouette, bis echte Fotos aus der Medienverwaltung kommen. */
export const Silhouette = ({ person = false, faint = false }: { person?: boolean; faint?: boolean }) => (
  <svg className={`bg ${s.silhouette} ${faint ? s.silhouetteFaint : ""}`} viewBox="0 0 100 100" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    {person ? (
      <>
        <circle cx="50" cy="34" r="13" fill="currentColor" />
        <path d="M12 100 C12 68 30 56 50 56 C70 56 88 68 88 100Z" fill="currentColor" />
      </>
    ) : (
      <>
        <circle cx="72" cy="30" r="9" fill="currentColor" />
        <path d="M0 100 L0 74 L24 48 L40 66 L58 40 L84 70 L100 56 L100 100Z" fill="currentColor" />
      </>
    )}
  </svg>
);

export const Logo = ({ size }: { size: number }) => (
  <svg width={size} height={size} viewBox="0 0 30 30" aria-hidden="true">
    <circle cx="15" cy="15" r="14" fill="#FFC83D" />
    <path d="M15 5 L19 15 L15 25 L11 15Z" fill="#10302F" />
  </svg>
);

export const ArrowRight = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const Check = ({ size, stroke, width }: { size: number; stroke: string; width: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth={width} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

/** Icon im 24er-Raster mit Strichstärke 2 (Kategorien, Eckdaten). */
export const Icon = ({ size, children }: { size: number; children: React.ReactNode }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#10302F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

const MONTHS = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

export type MonthSummary = { tmax: number; good: boolean };

/** Ohne Klimadaten nur die Monatsnamen; sonst Höchstwert und Markierung für Badewetter. */
export function MonthCells({ months }: { months?: MonthSummary[] | null }) {
  return (
    <>
      {MONTHS.map((label, i) => {
        const m = months?.[i];
        return (
          <span key={label} className={`${s.month} ${m?.good ? s.monthGood : ""}`}>
            {label}
            {m && <span className={s.monthTemp}>{Math.round(m.tmax)}°<span className="sr-only">C{m.good ? ", Badewetter" : ""}</span></span>}
          </span>
        );
      })}
    </>
  );
}
